import { useTranslation } from 'react-i18next';

import PageLayout from '@/components/Layout/PageLayout';

import type { HealthDetailPageId } from '../_config/healthDetailPageConfig';
import { getHealthDetailPageConfig } from '../_config/healthDetailPageConfig';
import HealthDetailDetections from '../components/HealthDetailDetections/HealthDetailDetections';
import HealthDetailInformationPanel from '../components/HealthDetailInformationPanel/HealthDetailInformationPanel';
import HealthDetailTemplate from '../components/HealthDetailTemplate/HealthDetailTemplate';
import HealthDevelopmentChart from '../components/HealthDevelopmentChart/HealthDevelopmentChart';
import HealthStatusChart from '../components/HealthStatusChart/HealthStatusChart';

import HealthDeformitiesTabBar from './components/HealthDeformitiesTabBar';

export interface HealthDeformitiesDetailPageProps {
    pageId: Extract<HealthDetailPageId, 'spine' | 'jaw' | 'gillLid'>;
}

export default function HealthDeformitiesDetailPage(props: HealthDeformitiesDetailPageProps) {
    const { pageId } = props;
    const { t } = useTranslation('healthModule');
    const pageConfig = getHealthDetailPageConfig(pageId);

    return (
        <PageLayout title={t('routes.deformities')} subtitle={t('routes.health')}>
            <HealthDeformitiesTabBar />
            <HealthDetailTemplate
                statusChart={
                    <HealthStatusChart healthParameterKey={pageConfig.healthParameterKey} />
                }
                developmentChart={
                    <HealthDevelopmentChart healthParameterKey={pageConfig.healthParameterKey} />
                }
                informationPanel={
                    <HealthDetailInformationPanel
                        healthParameterKey={pageConfig.healthParameterKey}
                        detailNamespace={pageConfig.detailNamespace}
                        routeLabelKey={pageConfig.routeLabelKey}
                    />
                }
                detections={
                    <HealthDetailDetections
                        healthParameterKey={pageConfig.healthParameterKey}
                        laksvelImageIndicator={pageConfig.laksvelImageIndicator}
                    />
                }
            />
        </PageLayout>
    );
}
